import React from 'react'

import PersonalTasteProfile from '../PersonalTasteProfile'
import Button from 'components/Button'
import { trackTasteProfileEvent } from 'utils/tagManager'
import styles from './accountPersonalTasteProfile.css'

const AccountPersonalTasteProfile = () => (
  <div>
    <PersonalTasteProfile />

    <div className={styles.buttonWrapper}>
      <Button
        href={process.env.WEBSHOP_SMAAKPROFIELEN_PATH + '/doe-de-test/'}
        className={styles.redoButton}
        size={'small'}
        {...trackTasteProfileEvent('Doe de test opnieuw')}
      >
        Doe de test opnieuw
      </Button>
    </div>
  </div>
)

export default AccountPersonalTasteProfile
